import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import moment from "moment";

import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";
import Button from "./../../components/general/Button/Button";
import Table from "./../../components/general/Table/Table";

import classes from './DrivePage.module.scss';
import Loading from "../../components/wrapper/Loading/Loading";

const roles = {
  1: "Admin",
  2: "User",
  3: "Owner",
  5: "Communication"
};

class TeamPage extends Component {
  state = {
    activeUsers: [],
    activityLog: [],
    isLoading: false
  };

  activeUserTableHeaders = ["id", "User", "Email", "Privilege Rights", "Last Login"];
  activeUserTableButtons = [
    {
      display: "Edit",
      onClickHandler: (index, id) => {
        this.props.history.push(`/dashboard/admin/team/user/edit/${id}`);
      }
    }
  ];

  activityLogTableHeaders = ["User", "Privilege Rights", "Action", "Date"];

  componentDidMount = async () => {
    let users = [];
    let logs = [];
    try {
      this.setState({
        isLoading: true
      })
      // load users
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/user/admin`, { withCredentials: true });
      if (res.status === 200 && res.data.admin) {
        users = res.data.admin.map((user) => [user.user_id, user.name, user.email, roles[user.privilege_id], ""]);
      }
      // load logs
      res = await axios.get(`${process.env.REACT_APP_API_HOST}/logs`, { withCredentials: true });
      if (res.status === 200 && res.data.logs.undefined) {
        logs = res.data.logs.undefined.map((log) => [log.message.split(' with privilege level ')[0], log.message.split('privilege level ')[1][0], log.message.split(log.message.split(' with privilege level ')[0] + ' with privilege level ' + log.message.split('privilege level ')[1][0] + ' ')[1], moment(log.timestamp)]);
      }
    } catch (err) {
      this.setState({
        isLoading: false
      })
      console.log(err);
    }
    this.setState({
      activeUsers: users,
      activityLog: logs,
      isLoading: false
    });
  };

  render() {
    return (
      <Fragment>
        <Loading loading={this.state.isLoading} label="Loading Boxi Team..."></Loading>
        <Helmet>
          <title>Boxi Admin | Boxi Team</title>
        </Helmet>
        <div className={`${classes.titleContainer} mb-4`}>
          <Title>Boxi Team</Title>
          <div className={classes.linksContainer}>
            <Link className={classes.linkTag} to="/dashboard/admin/team/user">
              + Create New User
            </Link>
          </div>
        </div>
        <Row className="mb-4">
          <Col>
            <Table
              id="active-user-table"
              title="Active Users"
              headers={this.activeUserTableHeaders}
              buttons={this.activeUserTableButtons}
              data={this.state.activeUsers}
              colors={["#787ff6", "#7bd5f5"]}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Table
              id="activity-log-table"
              title="Activity Log"
              headers={this.activityLogTableHeaders}
              data={this.state.activityLog}
              colors={["#FC575E", "#F7B42C"]}
            />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default withRouter(TeamPage);
